module.exports = __webpack_public_path__ + "static/media/pause_rectangle.5852a201.svg";